import React from 'react'
import { Outlet } from 'react-router-dom'

function Claims() {
  return (
    <div><Outlet /></div>
  )
}

export default Claims